import { BitSet } from './bitset';
export class ComponentMap {
    constructor() {
        this.bitmask = new BitSet(0);
        this.map = new Map();
    }
    get(ctor) {
        const component = this.map.get(ctor);
        return component != null ? component : undefined;
    }
    set(...components) {
        let mask = new BitSet(0);
        for (const component of components) {
            if (this.map.has(component.constructor) === false) {
                mask = mask.or(component.constructor.bitmask);
            }
            this.map.set(component.constructor, component);
        }
        this.bitmask = this.bitmask.or(mask);
    }
    remove(...componentCtors) {
        let mask = new BitSet(0);
        for (const componentCtor of componentCtors) {
            if (this.map.has(componentCtor)) {
                mask = mask.or(componentCtor.bitmask);
            }
            this.map.delete(componentCtor);
        }
        this.bitmask = this.bitmask.xor(mask);
    }
    clear() {
        this.map.clear();
        this.bitmask.clear();
    }
    keys() {
        return this.map.keys();
    }
    has(componentCtor) {
        return this.map.has(componentCtor);
    }
    get size() {
        return this.map.size;
    }
}
